import { Iconfont } from "@eweadn-qiankun/shared-components";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BoardList from "./BoardList";
import DeviceStatus from "./DeviceStatus";
import "./Menu.portal.scss";
import { getSidebarFlyoutLeft, useAnchoredFlyout } from "./useAnchoredFlyout";

interface ChildModalData {
  path?: string;
  menuType?: unknown;
}
interface ChildModalProps {
  useSdkApi?: unknown;
  data?: ChildModalData;
  mouseHIDHandle?: unknown;
  mouseDeviceInfo?: Record<string, unknown>;
  /** 点击菜单项强制打开（modal-active） */
  open?: boolean;
  disabled?: boolean;
  /** 侧栏是否折叠，用于计算 flyout 水平位置 */
  sidebarCollapsed?: boolean;
}
const ChildModal = (props: ChildModalProps) => {
  const { t } = useTranslation();
  const {
    useSdkApi,
    data,
    mouseHIDHandle,
    mouseDeviceInfo,
    open,
    disabled,
    sidebarCollapsed = false,
  } = props;
  const navigate = useNavigate();
  const sentinelRef = useRef<HTMLSpanElement>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setAnchorEl(
      sentinelRef.current?.closest<HTMLElement>(".child-list") ?? null
    );
  }, []);

  const getAnchor = useCallback(() => anchorEl, [anchorEl]);

  const { visible, pos, portalRef, portalHoverHandlers } = useAnchoredFlyout({
    getAnchor,
    forceOpen: open,
    disabled,
    fixedLeft: getSidebarFlyoutLeft(sidebarCollapsed),
    hideDelay: 300,
  });

  const menuCheck = (path: string) => {
    if (!path || path === "/" || path === "userInfo") {
      location.href = "/";
      return;
    }
    navigate(path);
  };
  const [modalData, setModalData] = useState<{
    title: string;
    moreText: string;
    path: string;
    desc: string;
  }>();
  useEffect(() => {
    if (data?.path === "userInfo") {
      setModalData({
        title: t("menu.modal.myDevices"),
        moreText: t("menu.modal.backToDeviceList"),
        path: data?.path,
        desc: t("menu.modal.connectedDevices"),
      });
    } else if (data?.path === "boardConfig") {
      setModalData({
        title: t("menu.modal.configFile"),
        moreText: t("menu.modal.moreConfig"),
        path: data?.path,
        desc: t("menu.modal.quickActivate"),
      });
    }
  }, [data, t]);

  const modalContent = (
    <div
      ref={portalRef}
      className={`child-modal-box child-modal-box--portal${visible ? " child-modal-box--portal-open" : ""}`}
      style={{
        left: pos.left,
        top: pos.top,
        // visibility: visible ? "visible" : "hidden",
        display: visible ? "block" : "none",
        pointerEvents: visible ? "auto" : "none",
      }}
      {...portalHoverHandlers}
    >
      <div className="child-modal">
        <div className="child-modal-main">
          <div className="child-modal-title-more">
            <div className="child-modal-title">{modalData?.title}</div>
            <div
              className="child-modal-more"
              onClick={() => menuCheck(data?.path ?? "")}
            >
              <span>{modalData?.moreText}</span>
              <Iconfont icon="chevronright" />
            </div>
          </div>
          <div className="child-modal-desc">{modalData?.desc}</div>
          <div className="configfile-list">
            {data?.path === "userInfo" ? (
              <DeviceStatus
                useSdkApi={useSdkApi}
                mouseDeviceInfo={mouseDeviceInfo}
              />
            ) : data?.path === "boardConfig" ? (
              <BoardList
                useSdkApi={useSdkApi}
                mouseHIDHandle={mouseHIDHandle}
                mouseDeviceInfo={mouseDeviceInfo}
                menuType={data?.menuType}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <span
        ref={sentinelRef}
        className="child-modal-anchor"
        aria-hidden
        hidden
      />
      {typeof document !== "undefined" &&
        createPortal(modalContent, document.body)}
    </>
  );
};
export default ChildModal;
